import { openModal } from 'components/Modal';

import { PRICE_SUBMIT_ERROR_MODAL_NAME } from './PriceSubmitErrorModal';

export function getNotListedOnline(formValues, { useLegacyCheckbox = false } = {}) {
  if (useLegacyCheckbox) return !!formValues.notListedOnline;
  return !(formValues.linkToPrice && formValues.linkToPrice.trim() !== '');
}

export function openPriceSubmitErrorModal(
  dispatch,
  { currencyCode, serviceName, linkToPrice, servicePrice, notListedOnline }
) {
  dispatch(
    openModal(PRICE_SUBMIT_ERROR_MODAL_NAME, {
      currencyCode,
      serviceName,
      linkToPrice,
      servicePrice,
      notListedOnline,
    })
  );
}
